<script setup>
  import { ref, computed, watch } from "vue";
  import { usePlanStore } from "@/stores/usePlanStore";
  import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";
  
  const emit = defineEmits(["close", "refresh"]);
  const store = usePlanStore();
  
  const isDeleting = ref(false);
  
  const selectedCount = computed(() => store.selectedPlanIds.length);
  
  // ✅ Congela contagem (porque seleção pode ser limpa no meio)
  const frozenCount = ref(0);
  
  // ✅ Congela IDs (pra deletar exatamente o que estava selecionado no clique)
  const frozenIds = ref([]);
  
  function freezeSnapshot() {
    frozenCount.value = selectedCount.value;
    frozenIds.value = Array.isArray(store.selectedPlanIds)
      ? [...store.selectedPlanIds]
      : [];
  }
  
  // Mantém congelado atualizado ENQUANTO NÃO está deletando
  watch(
    () => store.selectedPlanIds,
    () => {
      if (!isDeleting.value) freezeSnapshot();
    },
    { immediate: true, deep: true }
  );
  
  const modalTitle = "Apagar Planos em Lote";
  
  const messageTitle = computed(() => {
    const n = frozenCount.value || selectedCount.value;
  
    if (n <= 1) return "Você está prestes a apagar 1 plano selecionado.";
    return `Você está prestes a apagar ${n} planos selecionados.`;
  });
  
  const messageSubtitle = computed(() => "Esta ação não pode ser desfeita.");
  
  function buildErrorMessage(error) {
    return (
      error?.response?.data?.message ||
      error?.message ||
      "Ocorreu um erro ao excluir os planos."
    );
  }
  
  async function onConfirmDelete() {
    // ✅ congela ANTES de deletar (texto + alvo)
    freezeSnapshot();
    isDeleting.value = true;
  
    try {
      if (!frozenIds.value.length) {
        throw new Error("Nenhum plano selecionado para exclusão.");
      }
  
      // ✅ força a ação do store a usar exatamente o snapshot
      store.selectedPlanIds = [...frozenIds.value];
  
      await store.deleteSelectedPlans();
    } catch (error) {
      isDeleting.value = false;
      throw new Error(buildErrorMessage(error)); // toast vem do DeleteConfirmModal
    }
  }
  
  function handleSuccess() {
    emit("refresh");
    emit("close");
  }
  </script>
  
  <template>
    <DeleteConfirmModal
      :show="true"
      :title="modalTitle"
      :messageTitle="messageTitle"
      :messageSubtitle="messageSubtitle"
      confirmText="Sim, apagar"
      cancelText="Cancelar"
      loadingText="Apagando..."
      :onConfirm="onConfirmDelete"
      @success="handleSuccess"
      @close="!isDeleting && emit('close')"
    />
  </template>
  